import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

// Get GraphQL URL from environment variable with fallback
const WORDPRESS_GRAPHQL_URL = process.env.NEXT_PUBLIC_WORDPRESS_GRAPHQL_URL || 'https://api.okwintv.top/graphql'

// WordPress GraphQL endpoint với timeout configuration
const httpLink = createHttpLink({
  uri: WORDPRESS_GRAPHQL_URL,
  fetchOptions: {
    timeout: 10000, // 10 seconds timeout
    cache: 'default' // Change from force-cache to default for better timeout handling
  }
})

// Error handling link
const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    )
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`)
    // Don't retry on timeout errors during build
    if (networkError.message?.includes('timeout') || networkError.message?.includes('Connect Timeout')) {
      console.log('Timeout detected, skipping retry during build')
      return
    }
  }
})

// Thêm headers nếu cần authentication
const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      // Thêm API key nếu cần
      // 'Authorization': `Bearer ${process.env.NEXT_PUBLIC_WP_API_KEY}`,
    }
  }
})

export const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-first',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'cache-first', // Prefer cached data
      errorPolicy: 'all',
    },
  },
}) 